import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner8 from "../assets/banner8.jpg";
import banner2 from "../assets/banner2.jpg";
import banner1 from "../assets/banner1.jpg";
import { FaHandshake, FaTruckMoving, FaClipboardList, FaCogs } from "react-icons/fa";
import { MdListAlt, MdWhatsapp } from "react-icons/md";

export default function ServicesContent() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const processSteps = [
    "Customer Request – Clients share their material or transport requirements with us.",
    "Quotation & Proposal – We provide a detailed quotation based on the request.",
    "Agreement/Contract – Upon approval, we formalize engagement through a supply contract or purchase order.",
    "Delivery & Fulfillment – Materials are procured, quality-checked, and delivered on schedule.",
    "Payment & Support – Payment terms are honored, with after-sales support where needed."
  ];

  const coreServices = [
    {
      title: "Project Support Services",
      icon: <FaCogs size={30} color="var(--secondaryColor)" />,
      content: [
        "Procurement Services – Sourcing and supplying materials as per project requirements.",
        "Project Support – End-to-end assistance to minimize client workload.",
        "Installation Services – Professional installation of supplied materials and systems.",
        "After-Sales Support – Warranty services, maintenance, and troubleshooting."
      ],
			banner: banner8,
    },
    {
      title: "Transport & Logistics Services",
      icon: <FaTruckMoving size={30} color="var(--secondaryColor)" />,
      content: [
        "Material Transportation – Safe and timely delivery of construction materials.",
        "Cargo Services – Transportation of general cargo and equipment.",
        "Logistics Solutions – Supply chain management and coordination."
      ],
			banner: banner2,
    },
  ];

  async function init() {
    setReady(false);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (!ready)
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;

  return (
    <div
      className="MainBodySection bg-background"
      style={{ paddingTop: "50px", paddingBottom: "50px" }}
    >
      <div className="container">
        {/* --- TITLE --- */}
        <div className="row mb-4">
          <div className="col-md-12">
            <h6 className="main-section-title">
              Our Services
              <span
                style={{
                  display: "block",
                  borderBottom: "3px solid var(--secondaryColor)",
                  width: "50px",
                  marginTop: "10px",
                }}
              ></span>
            </h6>
          </div>

          {/* --- INTRO --- */}
          <div className="col-md-12 mb-4">
            <h6
              style={{ fontSize: "18px" }}
              className="mt-3 mb-3"
            >
              <span className="font-bold">Group V Limited</span> offers a complete range of
              services designed to make material procurement and delivery efficient,
              transparent, and stress-free for our clients.
            </h6>
          </div>

          {/* --- HOW WE WORK SECTION --- */}
          <div className="col-md-12 mb-4">
            <div
              className="card shadow-sm border-0"
              style={{
                borderRadius: "12px",
                padding: "25px",
                background: "white",
              }}
            >
              <div className="d-flex align-items-center mb-3">
                <FaClipboardList
                  size={30}
                  color="var(--secondaryColor)"
                  style={{ marginRight: "10px" }}
                />
                <h5 className="text-primary fw-bold mb-0">How We Work</h5>
              </div>
              <ol style={{ paddingLeft: "20px", marginBottom: "0" }}>
                {processSteps.map((step, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: "8px",
                      fontSize: "0.95rem",
                      color: "#555",
                      lineHeight: "1.6",
                    }}
                  >
                    {step}
                  </li>
                ))}
              </ol>
            </div>
          </div>

          {/* --- CORE SERVICES SECTION --- */}
          <div className="col-md-12 mb-4">
            <h5
              className="fw-bold text-primary mb-3"
              style={{ fontSize: "22px" }}
            >
              Core Services
            </h5>
            <div className="row">
              {coreServices.map((s, index) => (
                <div key={index} className="col-md-6 mb-4">
                  <div
                    className="card h-100 shadow-sm"
                    style={{
                      border: "none",
                      borderRadius: "12px",
                      overflow: "hidden",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        height: "180px",
                        backgroundImage: `url(${s.banner})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          background: "rgba(255,255,255,0.85)",
                          borderRadius: "50%",
                          padding: "8px",
                        }}
                      >
                        {s.icon}
                      </div>
                    </div>

                    <div className="card-body" style={{ padding: "20px" }}>
                      <h6
                        style={{
                          fontWeight: 600,
                          marginBottom: "15px",
                          fontSize: "24px",
                          color: "var(--textColor)",
                        }}
                      >
                        {s.title}
                      </h6>

                      <ul style={{ paddingLeft: "20px", marginBottom: "0" }}>
                        {s.content.map((item, i) => (
                          <li
                            key={i}
                            style={{
                              fontSize: "0.9rem",
                              lineHeight: "1.5",
                              color: "#555",
                              marginBottom: "5px",
                            }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* --- CALL TO ACTION BUTTONS --- */}
        <div className="container text-center mt-4">
          <button
            style={{ margin: "10px" }}
            className="btn btn-padded btn-outline-primary btn-rounded"
            onClick={() => {
              appContext.navTo({ item: "request_quote" });
            }}
          >
            <MdListAlt size={24} /> Request a Quote
          </button>

          <button
            style={{ margin: "10px" }}
            className="btn btn-padded btn-primary btn-rounded"
            onClick={() => {
              window.open("https://wa.me/255654253235", "_blank");
							
            }}
          >
            <MdWhatsapp size={24} /> Chat on Whatsapp
          </button>
        </div>
      </div>
    </div>
  );
}
